// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__WdVo6","input":"styles_input__1wkvE"};